import { Loading } from '@/shared/types/Loading'
import type { StatusState } from '../domain/StatusState'
import type { Order } from '../domain/Order'
import type { Picking } from '../domain/Picking'

export const getOrder = (state: StatusState) => (): Order =>
  state.immutable.order

export const getPicking = (state: StatusState) => (): Picking =>
  state.immutable.picking

export const isLoadOrderLoading = (state: StatusState) => (): boolean =>
  state.loading.loadOrder === Loading.PENDING
